const {
  required,
  sameAs,
  minLength,
  numeric,
  helpers,
} = require("vuelidate/lib/validators");

export const REGISTER_LOGIN_SCHEMA = {
  /* Form SCHEMA */
  schema: [
    {
      id: "mobile_number",
      label: "mobile_number",
      placeholder: "mobile_number",
      cols: 12,
      lg: 12,
      md: 12,
      sm: 12,
      type: "mobile",
    },
    {
      id: "password",
      label: "password",
      placeholder: "password",
      cols: 12,
      lg: 12,
      md: 12,
      sm: 12,
      type: "password",
    },
    {
      id: "confirm_password",
      label: "confirm_password",
      placeholder: "confirm_password",
      cols: 12,
      lg: 12,
      md: 12,
      sm: 12,
      type: "password",
    },
  ],

  /* Form MODEL */
  model: {
    mobile_number: null,
    password: null,
    confirm_password: null,
  },

  /* VALIDATION SCHEMA */
  validations: {
    form: {
      mobile_number: {
        required,
        numeric,
        phone_number: helpers.regex(
          "phone_number",
          /^[(]?[0-9]{3}[)]?[0-9]{3}?[0-9]{5}$/
        ),
      },
      password: { required, minLength: minLength(8) },
      confirm_password: { required, sameAsPassword: sameAs("password") },
    },
  },
};
